// extracted by mini-css-extract-plugin
export default {"TopSection":"JBGAE0B6","noPadding":"NTbp965X","PharmacyJourneyContentWrapper":"iw67gKWw","PharmacyJourneyWrapper":"o_wHS_u6","TopSectionDetailsPage":"czMpXQJw"};